import React, { useEffect, useState } from 'react'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  LinearProgress,
  Checkbox
} from '@material-ui/core'
import { useMutation } from 'react-admin'

const expectedPermissions = [
  { app: 'zicsa', menu: 'purchase_orders' },
  { app: 'zicsa', menu: 'invoices' },
  { app: 'zicsa', menu: 'status_invoices' },
  { app: 'zicsa', menu: 'invoices_journal' },
  { app: 'admin', menu: 'staff' }
]

const appLabel = (app) => {
  if (app === 'zicsa') {
    return 'Zicsa'
  }

  if (app === 'admin') {
    return 'Administracion'
  }

  return app
}

const menuLabel = (menu) => {
  if (menu === 'staff') {
    return 'Usuarios'
  }

  if (menu === 'purchase_orders') {
    return 'Ordenes de compra'
  }

  if (menu === 'invoices') {
    return 'Notas de ingreso'
  }

  if (menu === 'status_invoices') {
    return 'Estado facturas'
  }

  if (menu === 'invoices_journal') {
    return 'Registro pre-facturas'
  }

  return menu
}

const permissionKey = (permission) => `${permission.app}-${permission.menu}`

const PermissionEditableRow = ({ record }) => {
  const [read, setRead] = useState(record.read)
  const [write, setWrite] = useState(record.write)
  const [changeReadPermission, payloadRead] = useMutation()
  const [changeWritePermission, payloadWrite] = useMutation()

  useEffect(() => {
    setRead(record.read)
    setWrite(record.write)
  }, [record])

  const isPersisted = !!record.id

  const onChangeRead = (event) => {
    if (!isPersisted) {
      return
    }

    setRead(event.target.checked)

    changeReadPermission({
      type: 'update',
      resource: 'auth/users_permissions',
      payload: {
        id: record.id,
        data: { read: event.target.checked, updatedat: new Date() }
      }
    })
  }

  const onChangeWrite = (event) => {
    if (!isPersisted) {
      return
    }

    setWrite(event.target.checked)

    changeWritePermission({
      type: 'update',
      resource: 'auth/users_permissions',
      payload: {
        id: record.id,
        data: { write: event.target.checked, updatedat: new Date() }
      }
    })
  }

  return (
    <TableRow>
      <TableCell align="left">
        {appLabel(record.app)}
      </TableCell>
      <TableCell align="left">
        {menuLabel(record.menu)}
      </TableCell>
      <TableCell align="left">
        <Checkbox
          checked={read}
          disabled={!isPersisted || payloadRead.loading}
          onChange={(e) => onChangeRead(e)}
        />
      </TableCell>
      <TableCell align="left">
        <Checkbox
          checked={write}
          disabled={!isPersisted || payloadWrite.loading}
          onChange={(e) => onChangeWrite(e)}
        />
      </TableCell>
    </TableRow>
  )
}

const PermissionsEditableTable = ({ data, loaded }) => {
  const [permissions, setPermissions] = useState({})

  useEffect(() => {
    if (data) {
      const items = Object.values(data)
        .reduce((accu, permission) => {
          accu[permissionKey(permission)] = permission
          return accu
        }, {})

      setPermissions(items)
    }
  }, [data])

  if ((loaded && data) === false) {
    return <LinearProgress />
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell align="left">
            Aplicacion
          </TableCell>
          <TableCell align="left">
            Menu
          </TableCell>
          <TableCell align="left">
            Lectura
          </TableCell>
          <TableCell align="left">
            Escritura
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {
          expectedPermissions.map((expectedPermission) => {
            const record = permissions[permissionKey(expectedPermission)] || {
              ...expectedPermission,
              read: false,
              write: false
            }

            return (
              <PermissionEditableRow
                key={permissionKey(expectedPermission)}
                record={record}
              />
            )
          })
        }
      </TableBody>
    </Table>
  )
}

export default PermissionsEditableTable